import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useSearchState = (searchValue: string) => {
  const queryClient = useQueryClient();

  const updatePartSearch = (newQuery) => {
    queryClient.setQueryData(['searchValue'], newQuery);
  };

  const { data: partSearchedValue = searchValue } = useQuery<string>({
    queryKey: ['searchValue'],
    queryFn: () => queryClient.getQueryData(['searchValue']) || ''
  });

  return { partSearchedValue, updatePartSearch };
};
